<svg
    xmlns="http://www.w3.org/2000/svg"
    {...$$props}
    width="16"
    height="16"
    fill="none"
    ><path
        fill="#fff"
        fill-rule="evenodd"
        d="M8 2.583a5.417 5.417 0 0 0-4.323 8.68l7.587-7.587A5.39 5.39 0 0 0 8 2.583Zm4.325 2.154-7.588 7.587a5.417 5.417 0 0 0 7.587-7.587ZM1.084 8a6.917 6.917 0 1 1 13.833 0A6.917 6.917 0 0 1 1.084 8Z"
        clip-rule="evenodd"
    /></svg
>
